import { useEffect, useState } from "react";
import { Youtube, Lock } from "lucide-react";
import Logo from "@/components/Logo";

export const scrollToSection = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

const LINKS = [
  { href: "#videos", label: "Vidéos", testid: "nav-link-videos" },
  { href: "#groupe", label: "Le groupe", testid: "nav-link-groupe" },
  { href: "#dossier", label: "Dossier technique", testid: "nav-link-dossier" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#09090D]/75 border-b border-amber-500/15"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        <button
          data-testid="nav-logo-button"
          onClick={() => scrollToSection("#hero")}
          className="shrink-0"
          aria-label="Retour en haut"
        >
          <Logo size={38} />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => scrollToSection(l.href)}
              className="text-sm font-medium text-zinc-300 hover:text-amber-400 transition-colors duration-300 uppercase tracking-wider font-jbmono text-xs"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-youtube-link"
            href="https://www.youtube.com/@41fortyone"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2 text-xs font-jbmono uppercase tracking-wider text-zinc-300 hover:text-red-500 transition-colors duration-300 border border-zinc-700 hover:border-red-500/50 rounded-full px-4 py-2"
          >
            <Youtube size={15} />
            <span className="hidden lg:inline">YouTube</span>
          </a>
          <button
            data-testid="nav-booking-cta"
            onClick={() => scrollToSection("#booking")}
            className="bg-amber-500 hover:bg-amber-400 text-white text-xs sm:text-sm font-bold uppercase tracking-wider rounded-full px-4 sm:px-5 py-2.5 transition-colors duration-300"
          >
            Demander un concert
          </button>
          <a
            data-testid="nav-admin-link"
            href="/admin"
            aria-label="Espace admin"
            className="text-zinc-500 hover:text-amber-400 transition-colors duration-300 p-2"
          >
            <Lock size={16} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Nav;
